export const setValues = (values = {}, setValue) => {
  if (!setValue) {
    throw new Error("Missing argument setValue");
  }
  Object.entries(values).forEach(([name, value]) => setValue(name, value));
};
